import React, { useEffect, useState } from 'react'
import type { RetorikMainComponentProps, RetorikWidgetProps } from '../models/retorikTypes'
import getBaseAddress from '../utils/getBaseAddress'
import { fetchAvailableLanguagesAndGetCurrentLanguage } from '../utils/fetchAvailableLanguages'
import { getIntegrationModeAndWidgetConfigurationIfNeeded } from '../utils/getConfigs'
import RetorikAgent from './RetorikAgent'
import RetorikWidget from './RetorikWidget'
import { deepMerge } from '../utils/getThemeColors'

enum Integration {
  none,
  agent,
  widget
}

const RetorikFramework = (props: RetorikMainComponentProps & RetorikWidgetProps): JSX.Element => {
  const [integration, setIntegration] = useState<Integration>(Integration.none)
  const [widgetProps, setWidgetProps] = useState<RetorikMainComponentProps & RetorikWidgetProps>()

  useEffect(() => {
    const getData = async () => {
      const baseAddress = getBaseAddress(props.addressData)
      const language = await fetchAvailableLanguagesAndGetCurrentLanguage(baseAddress)
      const data = await getIntegrationModeAndWidgetConfigurationIfNeeded(baseAddress, language)

      if (data.integrationMode === 'widget') {
        const clonedProps = { ...props }
        // If we have a widget configuration in the props, let's use its data prior to the fetched ones
        if (clonedProps.widgetConfig) {
          data.widgetConfiguration && (clonedProps.widgetConfig = deepMerge(props.widgetConfig, data.widgetConfiguration))
        } else {
          clonedProps.widgetConfig = data.widgetConfiguration
        }
        setWidgetProps(clonedProps)
        setIntegration(Integration.widget)
      } else {
        setIntegration(Integration.agent)
      }

      // Call the render callback after we have defined which component to render
      props.renderCallback?.()
    }

    getData()
  }, [])

  return (
    <React.Fragment>
      {integration === Integration.agent && <RetorikAgent {...props} />}
      {integration === Integration.widget && widgetProps && <RetorikWidget {...widgetProps} fromRetorikFrameworkComponent={true} />}
    </React.Fragment>
  )
}

export default RetorikFramework
